import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing() * 2,
    marginRight: theme.spacing() * 2,
    [theme.breakpoints.up(965 + theme.spacing() * 2 * 2)]: {
      width: 965,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
});

const CenteredPageContentContainer = (props) => {
  const { classes } = props;

  return (
    <div id="layout" className={classes.layout}>
      {props.children}
    </div>
  );
};

CenteredPageContentContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
};

export default withStyles(styles)(CenteredPageContentContainer);



// WEBPACK FOOTER //
// ./src/components/CenteredPageContentContainer.js